import React from "react";
import { Route, Redirect } from "react-router-dom";
import useAuth from "../hooks/useAuth";

const GuestGuard = ({ component: Component, ...rest }) => {

    const { loading, isAuthenticated } = useAuth();

    return (
        <Route
            {...rest}
            render={(props) => {
                if (loading) {
                    return <div>Loading...</div>;
                }
                return !isAuthenticated
                    ? <Component {...props} />
                    : <Redirect to="/dashboard" />;
            }}
        />
    );
};

export default GuestGuard;